export const session_key = '_morinaga_session_key2023'

export const authRouteRegex = /\/scan./

export const phoneRegex =
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,7}$/im
